import { format, formatRelative } from 'date-fns';
import { de } from 'date-fns/locale';

export enum DateDisplayFormat {
  date = 'dd.MM.yyy',
  time = 'HH:mm',
  dateWithTime = 'dd.MM.yyy (HH:mm)',
  relativeToNow = 'relativeToNow',
}

const getDateObject = (dateString: string | null | undefined) => {
  if (!dateString) {
    return null;
  }

  const dateObject = new Date(dateString);

  if (dateObject.toString() === 'Invalid Date') {
    return null;
  }

  return dateObject;
};

export const formatDate = (
  date: Date | string | null | undefined,
  dateDisplayFormat: DateDisplayFormat = DateDisplayFormat.date,
) => {
  const dateObject = date instanceof Date ? date : getDateObject(date);

  if (!dateObject) return '';

  switch (dateDisplayFormat) {
    case DateDisplayFormat.date:
    case DateDisplayFormat.dateWithTime:
    case DateDisplayFormat.time:
      return format(dateObject, dateDisplayFormat);
    case DateDisplayFormat.relativeToNow:
      return formatRelative(dateObject, Date.now(), { locale: de });
  }
};
